module.exports = __webpack_public_path__ + "static/media/tyre-red-three5.352f644d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-three5.png
// module id = 348
// module chunks = 0